import { Flex } from 'antd';
import { IoClose } from 'react-icons/io5';
import styles from './index.module.scss';

const SelectChip = (props) => {
  const label = typeof props?.label === 'string' ? props?.label : props?.label?.props?.children;
  return (
    <Flex align="center" gap={2} className={styles.chip}>
      <div>{`${label?.slice(0, 10)}${label?.length > 10 ? '...' : ''}`}</div>
      {props?.closable && (
        <IoClose
          size={14}
          color="var(--gray-300)"
          className="cursorPointer"
          role="button"
          onClick={props?.onClose}
          style={{ color: 'var(--ant-color-primary' }}
        />
      )}
    </Flex>
  );
};

export default SelectChip;
